import { render, staticRenderFns } from "./OperaAliBillWindow.vue?vue&type=template&id=457d099d&"
import script from "./OperaAliBillWindow.vue?vue&type=script&lang=js&"
export * from "./OperaAliBillWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports